import styled from "@emotion/styled"
import * as api from "api"
import { CommonForm } from "common/forms"
import formatLicenseNumber from "common/utils/formatLicenceNumber"
import { Field } from "formik"

import { TextField } from "formik-mui"
import Shared from "theme/shared"
import schema, { initialFormState } from "./PromotionSchema"

const API_URL = process.env.API_URL
const getBenefitUrl = (licenceNumber: string, benefit?: api.Benefit) => {
  licenceNumber = formatLicenseNumber(licenceNumber)
  return `${API_URL}/BenefitPdf?benefitId=${
    benefit?.id
  }&serviceCenterName=${encodeURIComponent(
    benefit?.name,
  )}&licenceNumber=${licenceNumber}`
}

const Styled = {
  FormWrap: styled.div`
    padding: 15px 0 0;
  `,
  FormContainer: styled.div`
    display: flex;
    gap: 30px;
    align-items: flex-start;
    ${(p) => p.theme.breakpoints.down("sm")} {
      flex-direction: column;
      gap: 0;
    }
  `,
  Field: styled(Field)`
    flex-grow: 1;
  `,
  SendButton: styled(Shared.Button)`
    height: 35px;
    font-size: 14px;
    width: auto;
    width: 150px;
    white-space: nowrap;
    margin-top: 16px;
    flex-shrink: 0;
    ${(p) => p.theme.breakpoints.down("sm")} {
      width: 100%;
      margin-top: 0;
    }
  `,
}

type PromotionFormProps = {
  onSubmit: () => void
  benefit?: api.Benefit
}

const PromotionForm = ({ benefit, onSubmit }: PromotionFormProps) => {
  return (
    <Styled.FormWrap>
      <CommonForm
        validationSchema={schema}
        initialValues={initialFormState}
        onSubmit={async (values) => {
          const url = getBenefitUrl(values.licenceNumber, benefit)
          window.open(url, "_blank")
          onSubmit()
        }}
        render={() => (
          <Styled.FormContainer>
            <Styled.Field
              name="licenceNumber"
              id="licenceNumber"
              component={TextField}
              label="הכנס/י לוחית רישוי"
              type="tel"
              required
              placeholder="000-00-000"
              helperText=" " // prevent a "jump" when an error appears
              inputProps={{ maxLength: 10 }}
            />

            {/* TODO: Use LoadingButton */}
            <Styled.SendButton
              variant="contained"
              color="primary"
              type="submit"
            >
              הורדת קובץ הטבה
            </Styled.SendButton>
          </Styled.FormContainer>
        )}
      />
    </Styled.FormWrap>
  )
}

export default PromotionForm
